import { StateUtils } from '@spartacus/core';

export const MAIN_PHONE_FEATURE = 'main';
export const PHONE = '[Main Layout] Phone';

export interface MainPhoneMenu {
  [MAIN_PHONE_FEATURE]: MainPhoneState;
}

export interface MainPhoneState {
  phone: StateUtils.LoaderState<string>;
}
